// ========== SOURCE IDENTIFIER ==========
var EFX_WHEEL_SOURCE = 'popup';

async function efxSendToProxy(payload) {
    try {
        const r = await fetch('/apps/efx-mila', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
        });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return await r.json();
    } catch (e) {
        return null;
    }
}

// ========== COOKIE SYSTEM ==========
const EFX_COOKIE_NAME = 'efx_wheel_used';
const EFX_COOKIE_DAYS = 15;

const EFX_DISMISS_COOKIE_NAME = 'efx_wheel_dismissed';
const EFX_DISMISS_COOKIE_DAYS = 3;

const EFX_SPUN_COOKIE_NAME = 'efx_wheel_spun';
const EFX_SPUN_COOKIE_DAYS = 1;

function efxSetCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

function efxGetCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
}

function efxHasUsedWheel() {
    return efxGetCookie(EFX_COOKIE_NAME) === '1';
}

function efxMarkWheelUsed() {
    efxSetCookie(EFX_COOKIE_NAME, '1', EFX_COOKIE_DAYS);
}

function efxHasBeenDismissed() {
    return efxGetCookie(EFX_DISMISS_COOKIE_NAME) === '1';
}

function efxMarkDismissed() {
    efxSetCookie(EFX_DISMISS_COOKIE_NAME, '1', EFX_DISMISS_COOKIE_DAYS);
}

function efxHasSpunWheel() {
    return efxGetCookie(EFX_SPUN_COOKIE_NAME) === '1';
}

function efxMarkWheelSpun() {
    efxSetCookie(EFX_SPUN_COOKIE_NAME, '1', EFX_SPUN_COOKIE_DAYS);
}

// ========== IP CHECK SYSTEM ==========
async function efxCheckIpAllowed(wheelId) {
    try {
        const res = await efxSendToProxy({
            action: 'checkIpLimit',
            wheelId: wheelId || null,
            source: EFX_WHEEL_SOURCE,
            ts: Date.now()
        });
        if (!res) return { allowed: true };
        return {
            allowed: !!res.allowed,
            reason: res.reason || null,
            retryAfter: res.retry_after || null
        };
    } catch (e) {
        return { allowed: true };
    }
}

async function efxCheckIpSpin(wheelId) {
    try {
        const res = await efxSendToProxy({
            action: 'checkIpSpin',
            wheelId: wheelId || null,
            source: EFX_WHEEL_SOURCE,
            ts: Date.now()
        });
        if (!res) return { allowed: true };
        return {
            allowed: !!res.allowed,
            reason: res.reason || null
        };
    } catch (e) {
        return { allowed: true };
    }
}

// ========== DEFAULT TEXTS ==========
const EFX_DEFAULT_TEXTS = {
    main_title: 'Çarkı çevir, ödülünü kap!',
    main_subtitle: 'Üye ol, kodun anında gelsin. Kampanyalar için izinlerini seçebilirsin.',
    form_title: 'Üye Ol & Kuponu Al',
    form_subtitle: 'Bilgilerini gir, izinlerini seç, ödülünü gönderelim.',
    btn_spin: 'ÇEVİR',
    btn_submit_before_spin: 'Çarkı Çevir',
    btn_submit_after_spin: 'Ödülü Al',
    btn_submitting: 'Gönderiliyor...',
    btn_verify: 'Doğrula',
    btn_verifying: 'Doğrulanıyor...',
    btn_resend: 'Tekrar Gönder',
    btn_copy: 'Kopyala',
    btn_copied: 'Kopyalandı!',
    btn_completed: 'İşlem Tamamlandı',
    btn_limit_exceeded: 'Limit Aşıldı',
    win_label: 'Kazandın!',
    win_congrats: 'Tebrikler!',
    win_mobile_prefix: 'Tebrikler! Kazandın:',
    label_email: 'E-posta',
    label_phone: 'Telefon',
    placeholder_email: 'ornek@mail.com',
    placeholder_phone: '5XX XXX XX XX',
    phone_prefix: '+90',
    checkbox_kvkk_info: 'Kişisel verileriniz, <a href="{kvkk_url}" target="_blank">Müşteri Aydınlatma Metni</a> kapsamında işlenmektedir.',
    checkbox_marketing: 'Kampanya ve duyurulardan haberdar olmak istiyorum. {company_name} tarafıma ticari elektronik ileti göndermesine izin veriyorum. <a href="{marketing_url}" target="_blank">Detaylı bilgi</a>',
    checkbox_membership: '<a href="{membership_url}" target="_blank">Üyelik sözleşmesini</a> okudum, onaylıyorum.',
    checkbox_consent: 'Kişisel verilerimin <a href="{consent_url}" target="_blank">Açık Rıza Metni</a> uyarınca işlenmesini kabul ediyorum.',
    sms_title: '📱 SMS Doğrulama',
    sms_info: 'Telefonunuza gönderilen 6 haneli kodu girin',
    sms_placeholder: '• • • • • •',
    sms_success: 'Yeni kod gönderildi!',
    error_email: 'Geçerli bir e-posta adresi girin',
    error_phone: 'Geçerli bir telefon numarası girin (5XX ile başlamalı)',
    error_membership: 'Üyelik sözleşmesini onaylamalısınız',
    error_consent: 'Açık rıza metnini onaylamalısınız',
    error_sms_code: '6 haneli doğrulama kodunu girin',
    error_sms_send: 'SMS gönderilemedi. Lütfen tekrar deneyin.',
    error_sms_verify: 'Doğrulama kodu hatalı.',
    copy_success: 'Kopyalandı ✓',
    phone_conflict_message: 'Telefon numaranız başka bir kullanıcıda tanımlı.',
    support_link_text: 'Destek Ekibiyle İletişime Geç',
    reward_free_shipping: 'Ücretsiz Kargo',
    reward_fixed_amount_suffix: 'TL İndirim',
    reward_percent_prefix: '%',
    reward_percent_suffix: 'İndirim',
    url_kvkk: 'https://milagron.com/pages/kvkk',
    url_marketing: 'https://milagron.com/pages/ticari-elektronik-ileti-onay-metni',
    url_membership: 'https://milagron.com/pages/uyelik-sozlesmesi',
    url_consent: 'https://milagron.com/pages/kvkk',
    url_support: 'https://milagron.com/pages/iletisim',
    company_name: 'Milagron.com Elektronik Hizmetleri A.Ş.\'nin',
    error_ip_blocked: 'Bu çark daha önce kullanılmış. Lütfen daha sonra tekrar deneyin.',
};

// ========== DEFAULT COLORS ==========
const EFX_DEFAULT_COLORS = {
    accent: '#d4af37',
    accent_hover: '#b8952f',
    btn_text: '#ffffff',
    center_btn_bg: '#1a1a1a',
    center_btn_border: '#d4af37',
    pointer_color: '#d4af37',
    win_reward_color: '#d4af37',
    success_color: '#16a34a',
    error_color: '#dc2626',
    segment_colors: '#E53935,#FF9800,#8BC34A,#00BCD4,#3F51B5,#9C27B0,#F44336,#4CAF50,#2196F3,#FFEB3B',
};

function efxGetText(texts, key) {
    return (texts && texts[key]) || EFX_DEFAULT_TEXTS[key] || '';
}

function efxGetColor(colors, key) {
    return (colors && colors[key]) || EFX_DEFAULT_COLORS[key] || '';
}

function efxHexToRgb(hex) {
    hex = (hex || '').replace('#', '');
    if (hex.length !== 6) return '212,175,55';
    return [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16)].join(',');
}

function efxProcessText(texts, key) {
    let text = efxGetText(texts, key);
    text = text.replace(/\{kvkk_url\}/g, efxGetText(texts, 'url_kvkk'));
    text = text.replace(/\{marketing_url\}/g, efxGetText(texts, 'url_marketing'));
    text = text.replace(/\{membership_url\}/g, efxGetText(texts, 'url_membership'));
    text = text.replace(/\{consent_url\}/g, efxGetText(texts, 'url_consent'));
    text = text.replace(/\{support_url\}/g, efxGetText(texts, 'url_support'));
    text = text.replace(/\{company_name\}/g, efxGetText(texts, 'company_name'));
    return text;
}

function efxCheckTargeting(targeting) {
    if (!targeting) return true;
    const path = window.location.pathname.toLowerCase();
    const mode = targeting.mode || 'include';
    const showEverywhere = targeting.show_everywhere || false;
    if (mode === 'include' && showEverywhere) return true;
    const pageMatch = {
        isHome: path === '/' || path === '',
        isCart: path === '/cart' || path.startsWith('/cart/'),
        isProduct: path.startsWith('/products/'),
        isCollection: path.startsWith('/collections/')
    };
    let currentHandle = null;
    if (pageMatch.isProduct) {
        const match = path.match(/\/products\/([^/?#]+)/);
        if (match) currentHandle = match[1].toLowerCase();
    } else if (pageMatch.isCollection) {
        const match = path.match(/\/collections\/([^/?#]+)/);
        if (match) currentHandle = match[1].toLowerCase();
    }
    let isTargeted = false;
    const pages = targeting.pages || {};
    if (pageMatch.isHome && pages.home) isTargeted = true;
    if (pageMatch.isCart && pages.cart) isTargeted = true;
    const products = targeting.products || {};
    if (pageMatch.isProduct) {
        if (products.mode === 'all') isTargeted = true;
        else if (products.mode === 'specific' && currentHandle && (products.handles || []).includes(currentHandle)) isTargeted = true;
    }
    const collections = targeting.collections || {};
    if (pageMatch.isCollection) {
        if (collections.mode === 'all') isTargeted = true;
        else if (collections.mode === 'specific' && currentHandle && (collections.handles || []).includes(currentHandle)) isTargeted = true;
    }
    return mode === 'include' ? isTargeted : !isTargeted;
}

function efxPickWeighted(segments) {
    let total = 0;
    for (let i = 0; i < segments.length; i++) {
        const w = parseInt(segments[i].weight || 0, 10) || 0;
        if (w > 0) total += w;
    }
    if (total <= 0) {
        const idx = Math.floor(Math.random() * segments.length);
        return { seg: segments[idx], index: idx, total: segments.length };
    }
    let r = Math.random() * total;
    for (let i = 0; i < segments.length; i++) {
        const w = parseInt(segments[i].weight || 0, 10) || 0;
        if (w <= 0) continue;
        r -= w;
        if (r <= 0) return { seg: segments[i], index: i, total };
    }
    return { seg: segments[segments.length - 1] || null, index: segments.length - 1, total };
}

function efxOpenWheel(wheel) {
    const old = document.getElementById('efxGwOverlay');
    if (old) old.remove();

    const T = wheel.texts || {};
    const C = wheel.colors || {};
    const txt = (key) => efxGetText(T, key);
    const txtP = (key) => efxProcessText(T, key);
    const clr = (key) => efxGetColor(C, key);
    const esc = (s) => String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[c]);

    const accent = clr('accent');
    const accentHover = clr('accent_hover');
    const btnText = clr('btn_text');
    const centerBtnBg = clr('center_btn_bg');
    const centerBtnBorder = clr('center_btn_border');
    const pointerColor = clr('pointer_color');
    const winRewardColor = clr('win_reward_color');
    const successColor = clr('success_color');
    const errorColor = clr('error_color');
    const segmentColorsStr = clr('segment_colors');
    const segmentColorArr = segmentColorsStr.split(',').map(c => c.trim()).filter(Boolean);
    const accentRgb = efxHexToRgb(accent);

    const overlay = document.createElement('div');
    overlay.id = 'efxGwOverlay';
    overlay.className = 'efxGwOverlay';

    const segs = Array.isArray(wheel.segments) ? wheel.segments : [];
    const sliceCount = Math.max(1, segs.length);
    const sliceDeg = 360 / sliceCount;
    const isMobile = window.innerWidth <= 768;
    const size = isMobile ? 280 : 340;

    const wheelImageUrl = wheel.wheel_image || null;
    const pointerImageUrl = wheel.pointer_image || null;
    const buttonImageUrl = wheel.button_image || null;
    const backgroundImageUrl = wheel.background_image || null;
    const hasCustomImage = !!wheelImageUrl;
    const hasCustomPointer = !!pointerImageUrl;
    const hasCustomButton = !!buttonImageUrl;

    let diskStyle = '', labelsHtml = '';

    if (hasCustomImage) {
        diskStyle = `background-image:url('${wheelImageUrl}');background-size:cover;background-position:center;background-repeat:no-repeat;`;
    } else {
        const cx = size / 2, cy = size / 2, outerR = (size / 2) - 2;
        const colors = segmentColorArr.length > 0 ? segmentColorArr : ['#E53935', '#FF9800', '#8BC34A', '#00BCD4', '#3F51B5', '#9C27B0', '#F44336', '#4CAF50', '#2196F3', '#FFEB3B'];
        let paths = '';
        for (let i = 0; i < sliceCount; i++) {
            const start = (i * sliceDeg - 90) * Math.PI / 180;
            const end = ((i + 1) * sliceDeg - 90) * Math.PI / 180;
            const x1 = cx + outerR * Math.cos(start), y1 = cy + outerR * Math.sin(start);
            const x2 = cx + outerR * Math.cos(end), y2 = cy + outerR * Math.sin(end);
            const largeArc = sliceDeg > 180 ? 1 : 0;
            paths += `<path d="M ${cx} ${cy} L ${x1} ${y1} A ${outerR} ${outerR} 0 ${largeArc} 1 ${x2} ${y2} Z" fill="${colors[i % colors.length]}" stroke="rgba(255,255,255,0.5)" stroke-width="2"/>`;
        }
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">${paths}</svg>`;
        diskStyle = `background-image:url('data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}');background-size:cover;background-position:center;`;

        const labelRadius = outerR * 0.62, labelFontSize = isMobile ? 9 : 11, labelWidth = isMobile ? 70 : 85;
        labelsHtml = segs.map((s, i) => {
            const label = (s.label || `Dilim ${i + 1}`).toString().replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\s*-\s*/g, '<br>');
            const midAngleDeg = i * sliceDeg + sliceDeg / 2;
            const midAngleRad = (midAngleDeg - 90) * Math.PI / 180;
            const labelX = cx + labelRadius * Math.cos(midAngleRad), labelY = cy + labelRadius * Math.sin(midAngleRad);
            const color = i % 2 !== 0 ? '#ffffff' : '#111111';
            return `<div class="efxGwLabel" style="left:${labelX}px;top:${labelY}px;color:${color};font-size:${labelFontSize}px;width:${labelWidth}px;transform:translate(-50%,-50%) rotate(${midAngleDeg + 90}deg);">${label}</div>`;
        }).join('');
    }

    const pointerHtml = hasCustomPointer
        ? `<div class="efxGwPointer efxGwPointerCustom" style="background-image:url('${pointerImageUrl}');"></div>`
        : `<div class="efxGwPointer" style="border-top-color:${pointerColor};"></div>`;

    const centerHtml = hasCustomButton
        ? `<div class="efxGwCenter"><button type="button" class="efxGwCenterBtn efxGwCenterBtnCustom" data-act="spin" style="background-image:url('${buttonImageUrl}');"></button></div>`
        : `<div class="efxGwCenter"><button type="button" class="efxGwCenterBtn" data-act="spin" style="background:linear-gradient(145deg,${centerBtnBg} 0%,${centerBtnBg} 100%);border-color:${centerBtnBorder};color:${btnText};">${esc(txt('btn_spin'))}</button></div>`;

    // Arka plan görseli (sol panel) — görsel varsa metinler görselin üstünde tekrar olmasın diye gizlenir,
    // ve görsel tüm paneli kaplasın diye scrim gradyanı uygulanmaz
    // Görsel varsa: metinler gizlenir, çark görselin ÜSTÜNDE altta hizalanır (flex-end).
    // Mobilde background-position:top → görselin üst kısmı (içindeki yazılar) hep görünür,
    // kırpma alttan olur; çark altta durduğu için yazıların üstüne binmez. Panel min-height'i
    // DOM'a eklendikten sonra görselin oranına göre JS ile ayarlanır (vh yerine genişliğe bağlı).
    const leftStyle = backgroundImageUrl
        ? ` style="background-image:url('${backgroundImageUrl}');background-size:cover;background-repeat:no-repeat;justify-content:flex-end;${isMobile ? 'background-position:top center;' : 'background-position:center;'}"`
        : '';
    const leftHeaderHtml = backgroundImageUrl
        ? ''
        : `<div class="efxGwLeftHeader"><span class="efxGwGiftIcon">🎁</span><h2>${esc(txt('main_title'))}</h2></div>
                    <p class="efxGwSubtitle">${esc(txt('main_subtitle'))}</p>`;
    // Çark alttan hizalandığında alttan boşluk bırak (desktop 50px, mobil daha az)
    const wheelAreaStyle = backgroundImageUrl ? ` style="margin-bottom:${isMobile ? 24 : 50}px;"` : '';

    overlay.innerHTML = `
        <div class="efxGwModal">
            <button type="button" class="efxGwClose" data-act="close">✕</button>
            <div class="efxGwContent">
                <div class="efxGwLeft" data-section="wheel"${leftStyle}>
                    ${leftHeaderHtml}
                    <div class="efxGwWheelArea"${wheelAreaStyle}>
                        ${pointerHtml}
                        <div class="efxGwStage" style="width:${size}px;height:${size}px;">
                            <div class="efxGwDisk ${hasCustomImage ? 'efxGwDiskCustom' : ''}" id="efxGwDisk" style="${diskStyle}">${labelsHtml}</div>
                            ${centerHtml}
                            <div class="efxGwWinOverlay" data-el="winBanner" style="display:none;">
                                <div class="efxGwWinContent"><span class="efxGwWinIcon">🎉</span><span class="efxGwWinLabel">${esc(txt('win_label'))}</span><strong data-el="winReward" class="efxGwWinReward"></strong></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="efxGwRight ${isMobile ? 'efxGwHiddenMobile' : ''}" data-section="form">
                    <div class="efxGwMobileWinBanner" data-el="mobileWinBanner"><span class="efxGwMobileWinIcon">🎉</span><div class="efxGwMobileWinText"><span>${esc(txt('win_mobile_prefix'))}</span><strong data-el="mobileWinReward"></strong></div></div>
                    <img src="https://cdn.shopify.com/s/files/1/0534/9805/2781/files/Screenshot_4-removebg-preview.png?v=1780591625" alt="" class="efxGwFormImage" style="display:block;margin:0 auto 5px;max-width:60px;width:100%;height:auto;">
                    <h2 style="text-align:center;">${esc(txt('form_title'))}</h2>
                    <p class="efxGwFormSubtitle" style="text-align:center;">${esc(txt('form_subtitle'))}</p>
                    <div class="efxGwFormArea">
                        <div class="efxGwInputGroup"><label><span class="efxGwInputIcon">✉</span> ${esc(txt('label_email'))}</label><input type="email" data-el="emailInput" placeholder="${esc(txt('placeholder_email'))}" class="efxGwInput" required></div>
                        <div class="efxGwInputGroup"><label><span class="efxGwInputIcon">📱</span> ${esc(txt('label_phone'))}</label><div class="efxGwPhoneWrap"><span class="efxGwPhonePrefix">${esc(txt('phone_prefix'))}</span><input type="tel" data-el="phoneInput" placeholder="${esc(txt('placeholder_phone'))}" class="efxGwInput efxGwPhoneInput" maxlength="10" required></div></div>
                        <div class="efxGwCheckboxes">
                            <div class="efxGwCheckboxRow"><label>${txtP('checkbox_kvkk_info')}</label></div>
                            <div class="efxGwCheckboxRow"><input type="checkbox" id="efxMarketing" data-el="marketing"><label for="efxMarketing">${txtP('checkbox_marketing')}</label></div>
                            <div class="efxGwCheckboxRow"><input type="checkbox" id="efxMembership" data-el="membership" required><label for="efxMembership">${txtP('checkbox_membership')}</label></div>
                            <div class="efxGwCheckboxRow"><input type="checkbox" id="efxConsent" data-el="consent" required><label for="efxConsent">${txtP('checkbox_consent')}</label></div>
                        </div>
                        <button type="button" class="efxGwSubmitBtn" data-act="sendSms">${esc(txt('btn_submit_before_spin'))}</button>
                        <div data-el="formError" class="efxGwError"></div>
                    </div>
                    <div class="efxGwSmsArea" data-section="sms" style="display:none;">
                        <h3>${esc(txt('sms_title'))}</h3>
                        <p class="efxGwSmsInfo">${esc(txt('sms_info'))}</p>
                        <input type="text" data-el="smsCode" class="efxGwSmsInput" maxlength="6" placeholder="${esc(txt('sms_placeholder'))}" inputmode="numeric">
                        <div class="efxGwSmsActions"><button type="button" data-act="verifySms" class="efxGwSubmitBtn">${esc(txt('btn_verify'))}</button><button type="button" data-act="resendSms" class="efxGwResendBtn">${esc(txt('btn_resend'))}</button></div>
                        <div data-el="smsError" class="efxGwError"></div><div data-el="smsSuccess" class="efxGwSuccess"></div>
                    </div>
                    <div class="efxGwCodeArea" data-section="code" style="display:none;">
                        <div class="efxGwCodeSuccess"><span class="efxGwSuccessIcon">🎉</span><h3>${esc(txt('win_congrats'))}</h3><p data-el="rewardText"></p></div>
                        <div class="efxGwCodeBox"><span data-el="finalCode" class="efxGwFinalCode"></span><button type="button" data-act="copyCode" class="efxGwCopyBtn">${esc(txt('btn_copy'))}</button></div>
                        <div data-el="copyMsg" class="efxGwCopyMsg">${esc(txt('copy_success'))}</div>
                    </div>
                </div>
            </div>
        </div>`;

    overlay.style.setProperty('--efx-accent', accent);
    overlay.style.setProperty('--efx-accent-hover', accentHover);
    overlay.style.setProperty('--efx-accent-rgb', accentRgb);
    overlay.style.setProperty('--efx-btn-text', btnText);
    overlay.style.setProperty('--efx-center-btn-bg', centerBtnBg);
    overlay.style.setProperty('--efx-center-btn-border', centerBtnBorder);
    overlay.style.setProperty('--efx-pointer-color', pointerColor);
    overlay.style.setProperty('--efx-win-reward', winRewardColor);
    overlay.style.setProperty('--efx-success', successColor);
    overlay.style.setProperty('--efx-error', errorColor);

    let formSubmitted = false;

    function close() {
        if (!formSubmitted && !efxHasUsedWheel()) {
            efxMarkDismissed();
        }
        overlay.remove();
        document.documentElement.style.overflow = '';
    }
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    overlay.querySelector('[data-act="close"]').addEventListener('click', close);

    const btnSpinCenter = overlay.querySelector('.efxGwCenterBtn[data-act="spin"]');
    const diskEl = overlay.querySelector('#efxGwDisk');
    const leftSection = overlay.querySelector('.efxGwLeft');
    const rightSection = overlay.querySelector('.efxGwRight');
    const formArea = overlay.querySelector('.efxGwFormArea');
    const smsArea = overlay.querySelector('.efxGwSmsArea');
    const codeArea = overlay.querySelector('.efxGwCodeArea');

    let spinning = false, currentDeg = 0, spinLocked = false, pendingResult = null;

    const emailInput = overlay.querySelector('[data-el="emailInput"]');
    const phoneInput = overlay.querySelector('[data-el="phoneInput"]');
    const marketingCheck = overlay.querySelector('[data-el="marketing"]');
    const membershipCheck = overlay.querySelector('[data-el="membership"]');
    const consentCheck = overlay.querySelector('[data-el="consent"]');
    const formError = overlay.querySelector('[data-el="formError"]');
    const submitBtn = overlay.querySelector('[data-act="sendSms"]');

    phoneInput.addEventListener('input', (e) => {
        let val = e.target.value.replace(/\D/g, '');
        if (val.startsWith('0')) val = val.substring(1);
        if (val.length > 10) val = val.substring(0, 10);
        e.target.value = val;
    });

    function buildRewardText(seg) {
        let rewardText = seg?.label || 'Ödül';
        const rt = seg?.rewardType, rv = seg?.rewardValue;
        if (rt === 'free_shipping') rewardText = txt('reward_free_shipping');
        else if (rt === 'fixed_amount') rewardText = (rv || '') + ' ' + txt('reward_fixed_amount_suffix');
        else if (rt === 'percent') rewardText = txt('reward_percent_prefix') + (rv || '') + ' ' + txt('reward_percent_suffix');
        return rewardText;
    }

    async function doSpin() {
        if (spinning || spinLocked || !segs.length) return;

        btnSpinCenter.disabled = true;
        const ipCheck = await efxCheckIpSpin(wheel?.id);
        if (!ipCheck.allowed) {
            const errorMsg = ipCheck.reason || txt('error_ip_blocked');
            formError.textContent = errorMsg;
            formError.style.display = 'block';
            btnSpinCenter.disabled = true;
            btnSpinCenter.style.opacity = '0.5';
            btnSpinCenter.style.cursor = 'not-allowed';
            return;
        }

        spinning = true;
        efxMarkWheelSpun();

        const picked = efxPickWeighted(segs);
        const centerAngle = picked.index * sliceDeg + sliceDeg / 2;
        const extraTurns = 5;
        const jitter = (Math.random() - 0.5) * (sliceDeg * 0.6);
        const targetDeg = extraTurns * 360 + (360 - centerAngle) + jitter;
        currentDeg = ((currentDeg % 360) + 360) % 360;
        const finalDeg = Math.floor(currentDeg / 360) * 360 + targetDeg;
        diskEl.style.transform = `rotate(${finalDeg}deg)`;
        currentDeg = finalDeg;

        setTimeout(async () => {
            spinning = false;
            showConfetti();
            const apiRes = await efxSendToProxy({ action: 'wheelSpinResult', wheelId: wheel?.id || null, source: EFX_WHEEL_SOURCE, segmentIndex: picked.index, segmentId: picked.seg?.id || null, label: picked.seg?.label || null, rewardType: picked.seg?.rewardType || null, rewardValue: picked.seg?.rewardValue || null, ts: Date.now() });
            if (apiRes && apiRes.ok) {
                const rewardText = buildRewardText(picked.seg);
                pendingResult = { resultId: apiRes.result_id, wheelId: wheel?.id || null, segmentIndex: picked.index, rewardText: rewardText };
                overlay.querySelector('[data-el="winBanner"]').style.display = 'flex';
                overlay.querySelector('[data-el="winReward"]').textContent = rewardText;
                submitBtn.textContent = txt('btn_submit_after_spin');
                if (isMobile) {
                    setTimeout(() => {
                        const mobileWinReward = overlay.querySelector('[data-el="mobileWinReward"]');
                        if (mobileWinReward) mobileWinReward.textContent = rewardText;
                        leftSection.classList.add('efxGwHiddenMobile');
                        rightSection.classList.remove('efxGwHiddenMobile');

                        const modal = overlay.querySelector('.efxGwModal');
                        if (modal) modal.scrollTop = 0;
                        overlay.scrollTop = 0;

                    }, 1500);
                }
                spinLocked = true;
                btnSpinCenter.style.display = 'none';
            }
        }, 2000);
    }

    btnSpinCenter.addEventListener('click', doSpin);

    submitBtn.addEventListener('click', async () => {
        if (!pendingResult) { doSpin(); return; }
        const email = (emailInput.value || '').trim();
        const phone = (phoneInput.value || '').replace(/\D/g, '');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { formError.textContent = txt('error_email'); formError.style.display = 'block'; return; }
        if (!phone || phone.length !== 10 || !/^5\d{9}$/.test(phone)) { formError.textContent = txt('error_phone'); formError.style.display = 'block'; return; }
        if (!membershipCheck.checked) { formError.textContent = txt('error_membership'); formError.style.display = 'block'; return; }
        if (!consentCheck.checked) { formError.textContent = txt('error_consent'); formError.style.display = 'block'; return; }
        formError.style.display = 'none';
        submitBtn.disabled = true;
        submitBtn.textContent = txt('btn_submitting');
        const res = await efxSendToProxy({ action: 'sendVerificationSms', resultId: pendingResult.resultId, source: EFX_WHEEL_SOURCE, email, phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex, marketing: marketingCheck.checked });
        if (res && res.ok) {
            formSubmitted = true;
            pendingResult.email = email; pendingResult.phone = phone; pendingResult.smsId = res.sms_id || null;
            formArea.style.display = 'none'; smsArea.style.display = 'flex';
            const rightH2 = overlay.querySelector('.efxGwRight h2'), formSubtitle = overlay.querySelector('.efxGwFormSubtitle');
            if (rightH2) rightH2.style.display = 'none';
            if (formSubtitle) formSubtitle.style.display = 'none';
        } else {
            formError.textContent = res?.error || txt('error_sms_send');
            formError.style.display = 'block';
            submitBtn.disabled = false;
            submitBtn.textContent = txt('btn_submit_after_spin');
        }
    });

    const smsCodeInput = overlay.querySelector('[data-el="smsCode"]');
    const verifyBtn = overlay.querySelector('[data-act="verifySms"]');
    const resendBtn = overlay.querySelector('[data-act="resendSms"]');
    const smsError = overlay.querySelector('[data-el="smsError"]');
    const smsSuccess = overlay.querySelector('[data-el="smsSuccess"]');

    smsCodeInput.addEventListener('input', (e) => { e.target.value = e.target.value.replace(/\D/g, '').substring(0, 6); });

    verifyBtn.addEventListener('click', async () => {
        const code = (smsCodeInput.value || '').trim();
        if (!code || code.length !== 6) { smsError.textContent = txt('error_sms_code'); smsError.style.display = 'block'; return; }
        smsError.style.display = 'none'; verifyBtn.disabled = true; verifyBtn.textContent = txt('btn_verifying');
        const res = await efxSendToProxy({ action: 'verifySmsCode', resultId: pendingResult.resultId, source: EFX_WHEEL_SOURCE, smsId: pendingResult.smsId, code, email: pendingResult.email, phone: pendingResult.phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex });

        if (res && res.error_type === 'phone_conflict') {
            smsArea.style.display = 'none';
            codeArea.style.display = 'flex';
            if (isMobile) {
                const mobileWinBanner = overlay.querySelector('[data-el="mobileWinBanner"]');
                if (mobileWinBanner) mobileWinBanner.style.display = 'none';
            }
            const codeSuccess = codeArea.querySelector('.efxGwCodeSuccess');
            const codeBox = codeArea.querySelector('.efxGwCodeBox');
            const copyMsg = codeArea.querySelector('[data-el="copyMsg"]');
            if (codeSuccess) codeSuccess.style.display = 'none';
            if (codeBox) codeBox.style.display = 'none';
            if (copyMsg) copyMsg.style.display = 'none';
            showPhoneConflictWarning(res.error);
            return;
        }

        if (res && res.ok && res.code) {
            efxMarkWheelUsed();
            showFinalCode(pendingResult.rewardText, res.code);
        } else {
            smsError.textContent = res?.error || txt('error_sms_verify'); smsError.style.display = 'block';
            const criticalErrors = ['kod kalmadı', 'Maksimum', 'limiti aşıldı', 'bulunamadı'];
            if (criticalErrors.some(err => (res?.error || '').toLowerCase().includes(err.toLowerCase()))) {
                verifyBtn.disabled = true; verifyBtn.textContent = txt('btn_completed'); resendBtn.disabled = true; smsCodeInput.disabled = true;
            } else { verifyBtn.disabled = false; verifyBtn.textContent = txt('btn_verify'); smsCodeInput.value = ''; smsCodeInput.focus(); }
        }
    });

    resendBtn.addEventListener('click', async () => {
        resendBtn.disabled = true; resendBtn.textContent = txt('btn_submitting'); smsError.style.display = 'none';
        const res = await efxSendToProxy({ action: 'sendVerificationSms', resultId: pendingResult.resultId, source: EFX_WHEEL_SOURCE, email: pendingResult.email, phone: pendingResult.phone, wheelId: pendingResult.wheelId, segmentIndex: pendingResult.segmentIndex, resend: true });
        if (res && res.ok) {
            pendingResult.smsId = res.sms_id || null;
            smsSuccess.textContent = txt('sms_success'); smsSuccess.style.display = 'block';
            setTimeout(() => { smsSuccess.style.display = 'none'; }, 3000);
            resendBtn.disabled = false; resendBtn.textContent = txt('btn_resend');
        } else {
            const criticalErrors = ['Maksimum', 'limiti aşıldı', 'hakkınızı kullandınız'];
            if (criticalErrors.some(err => (res?.error || '').toLowerCase().includes(err.toLowerCase()))) {
                smsError.textContent = res?.error || txt('error_sms_send'); smsError.style.display = 'block'; resendBtn.disabled = true; resendBtn.textContent = txt('btn_limit_exceeded');
            } else { smsError.textContent = res?.error || txt('error_sms_send'); smsError.style.display = 'block'; resendBtn.disabled = false; resendBtn.textContent = txt('btn_resend'); }
        }
    });

    smsCodeInput.addEventListener('keypress', (e) => { if (e.key === 'Enter') verifyBtn.click(); });

    function showFinalCode(rewardText, code) {
        smsArea.style.display = 'none'; codeArea.style.display = 'flex';
        if (isMobile) {
            const mobileWinBanner = overlay.querySelector('[data-el="mobileWinBanner"]'), rightH2 = overlay.querySelector('.efxGwRight h2'), formSubtitle = overlay.querySelector('.efxGwFormSubtitle');
            if (mobileWinBanner) mobileWinBanner.style.display = 'none';
            if (rightH2) rightH2.style.display = 'none';
            if (formSubtitle) formSubtitle.style.display = 'none';
        }
        overlay.querySelector('[data-el="rewardText"]').textContent = rewardText;
        overlay.querySelector('[data-el="finalCode"]').textContent = code;
        const copyBtn = overlay.querySelector('[data-act="copyCode"]'), copyMsg = overlay.querySelector('[data-el="copyMsg"]');
        copyBtn.addEventListener('click', async () => {
            try { await navigator.clipboard.writeText(code); copyMsg.style.display = 'block'; copyBtn.textContent = txt('btn_copied'); copyBtn.disabled = true; setTimeout(() => close(), 2000); } catch (e) { }
        });
    }

    function showPhoneConflictWarning(message) {
        const warningDiv = document.createElement('div');
        warningDiv.className = 'efxGwPhoneConflict';
        warningDiv.innerHTML = `
            <div class="efxGwConflictIcon">⚠️</div>
            <h3 style="margin:10px 0;color:#c0392b;">İşlem Tamamlanamadı</h3>
            <p class="efxGwConflictText">${message || txt('phone_conflict_message')}</p>
            <a href="${txt('url_support')}" target="_blank" rel="noopener noreferrer" class="efxGwConflictBtn">${txt('support_link_text')}</a>
        `;
        codeArea.appendChild(warningDiv);
    }

    function showConfetti() {
        const old = document.getElementById('efxConfettiWrap');
        if (old) old.remove();
        const wrap = document.createElement('div');
        wrap.id = 'efxConfettiWrap';
        wrap.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999999;overflow:hidden;';
        if (!document.getElementById('efxConfettiCSS')) {
            const css = document.createElement('style');
            css.id = 'efxConfettiCSS';
            css.textContent = `@keyframes efxDrop{0%{top:-5%;opacity:1}100%{top:105%;opacity:0.8}}@keyframes efxSwing{0%,100%{margin-left:0}50%{margin-left:25px}}@keyframes efxTwist{0%{transform:rotate3d(1,1,0,0deg)}100%{transform:rotate3d(1,1,0,360deg)}}`;
            document.head.appendChild(css);
        }
        const confettiColors = ['#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6', '#1abc9c', '#e91e63', '#00bcd4', '#ffeb3b', '#ff5722'];
        for (let i = 0; i < 80; i++) {
            const p = document.createElement('div');
            const c = confettiColors[Math.floor(Math.random() * confettiColors.length)];
            const x = Math.random() * 100, w = 7 + Math.random() * 6, h = 10 + Math.random() * 8;
            const fall = 2.5 + Math.random() * 2.5, swing = 1.5 + Math.random() * 1.5, twist = 1 + Math.random() * 2, delay = Math.random() * 1.5;
            p.style.cssText = `position:absolute;left:${x}%;top:-5%;width:${w}px;height:${h}px;background:${c};border-radius:2px;animation:efxDrop ${fall}s linear ${delay}s forwards,efxSwing ${swing}s ease-in-out ${delay}s infinite alternate,efxTwist ${twist}s linear ${delay}s infinite;`;
            wrap.appendChild(p);
        }
        document.body.appendChild(wrap);
        setTimeout(() => wrap.remove(), 6000);
    }

    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';

    // Mobilde sol panel yüksekliğini görselin gerçek en-boy oranına göre ayarla.
    // Böylece yükseklik ekran yüksekliğine (vh) değil panel genişliğine bağlı olur ve
    // görsel kırpılmadan tam görünür; çark da altta hizalı kalır.
    if (backgroundImageUrl && isMobile && leftSection) {
        const applyLeftHeight = () => {
            const bgImg = new Image();
            bgImg.onload = () => {
                if (!bgImg.naturalWidth || !bgImg.naturalHeight) return;
                const ratio = bgImg.naturalHeight / bgImg.naturalWidth;
                const w = leftSection.clientWidth;
                if (!w) return;
                // Panel = görselin tam yüksekliği (görsel komple görünür) ama en az çark +
                // üstte yazı için yer kalacak kadar (size+200). Görsel kısaysa cover alttan
                // kırpar, üstteki yazı yine görünür; çark altta kaldığı için yazıyı kapatmaz.
                const imgH = Math.round(w * ratio);
                leftSection.style.minHeight = Math.max(imgH, size + 200) + 'px';
            };
            bgImg.src = backgroundImageUrl;
        };
        applyLeftHeight();
        window.addEventListener('resize', applyLeftHeight);
    }
}


function efxPreloadImages(wheel) {
    const urls = [wheel.wheel_image, wheel.pointer_image, wheel.button_image, wheel.background_image].filter(Boolean);
    if (urls.length === 0) return Promise.resolve();
    
    return new Promise((resolve) => {
        let loaded = 0;
        const total = urls.length;
        const timeout = setTimeout(resolve, 5000);
        
        urls.forEach(url => {
            const img = new Image();
            img.onload = img.onerror = () => {
                loaded++;
                if (loaded >= total) { clearTimeout(timeout); resolve(); }
            };
            img.src = url;
        });
    });
}

function efxOpenWheelWithDelay(wheel, delaySeconds) {
    const openAfterPreload = () => efxPreloadImages(wheel).then(() => efxOpenWheel(wheel));
    
    if (!delaySeconds || delaySeconds <= 0) { openAfterPreload(); return; }
    
    const delayMs = delaySeconds * 1000;
    const preloadPromise = efxPreloadImages(wheel);
    
    const timerId = setTimeout(() => {
        const doOpen = () => preloadPromise.then(() => efxOpenWheel(wheel));
        if (document.visibilityState === 'visible') { doOpen(); }
        else {
            const visibilityHandler = () => {
                if (document.visibilityState === 'visible') {
                    document.removeEventListener('visibilitychange', visibilityHandler);
                    doOpen();
                }
            };
            document.addEventListener('visibilitychange', visibilityHandler);
        }
    }, delayMs);
    window.addEventListener('beforeunload', () => { clearTimeout(timerId); }, { once: true });
}



async function initWheels() {
    if (efxHasUsedWheel()) return;
    if (efxHasSpunWheel()) return;
    if (efxHasBeenDismissed()) return;

    const currentPath = window.location.pathname;
    const res = await efxSendToProxy({ action: 'getWheels', onlyActive: 1, currentPath: currentPath });
    if (!res || !res.ok || !Array.isArray(res.wheels) || res.wheels.length === 0) return;
    const wheel = res.wheels[0];

    const ipCheck = await efxCheckIpAllowed(wheel.id);
    if (!ipCheck.allowed) return;

    const delaySeconds = parseInt(wheel.delay_seconds || 0, 10);
    efxOpenWheelWithDelay(wheel, delaySeconds);
}



initWheels();